import { useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";

import Checkbox from "@mui/material/Checkbox";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import { Grid, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { validateAadharNumber, validateMobileNumber, validateEmail, validatePassword, validateText, validateTextalone, validateDrivingLicense, validatePanCardNumber, validateBankAccountNumber, validateIFSCCode, validateGSTNumber } from "../../tables/validations";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/backgroundss.jpg";
import Swal from "sweetalert2";
import api from "core/interceptors/api";

export const Nonregistered = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [vendorPhoto, setVendorPhoto] = useState(null);
    const [shopPhoto, setShopPhoto] = useState(null);
    const [gpsPhoto, setGpsPhoto] = useState(null);
    const [Input, setInput] = useState({});
    const [Inputservices , setInputservices] = useState({});
    const [validationErrors, setValidationErrors] = useState({});
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [isEditingStep1, setIsEditingStep1] = useState(false); 
    const [isEditingStep2, setIsEditingStep2] = useState(false);
    const [getrole, setGetrole] = useState(null);
    const [servicetype, setServicetype] = useState(null);
    const [isEditingserviceStep1, setIsEditingserviceStep1] = useState(false);
    const [isOthers, setIsOthers] = useState(false);
    const [isSaveservicesEnabled, setIsSaveservicesEnabled] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [newpreviewVideos, setPreviewVideos] = useState([]);
    const [newVideos, setNewVideos] = useState([]);
    const [availability, setAvailability] = useState({
        monday: { enabled: false},
        tuesday: { enabled: false},
        wednesday: { enabled: false },
        thursday: { enabled: false },
        friday: { enabled: false },
        saturday: { enabled: false},
        sunday: { enabled: false},
       
      });
      const [selectedDays, setSelectedDays] = useState([]);
     const handleBankDetailsChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;
    
    
          if (name === "aadharNumber") {
            // Remove non-digit characters for Aadhar number only
            formattedValue = value.replace(/\D/g, ""); // Remove non-digit characters
            // Add hyphens after every 4 digits
            formattedValue = formattedValue
              .match(/.{1,4}/g) // Split into groups of 4 digits
              ?.join("-") // Join groups with a "-"
              .substring(0, 14); // Limit to 12 digits + 2 hyphens
          }
    
          const updatedInput = { ...Input, [name]: formattedValue };
          setInput(updatedInput);
          
      
        let errors = "";
      
        // Validate based on the field type
        if (name === "accountHolderName") {
          errors = validateText(value); // Example: generic text validation
        } else if (name === "panCardNumber") {
          errors = validatePanCardNumber(value);
         } else if (name === "accountNumber") {
          errors = validateBankAccountNumber(value); // Custom validation for account number
        } else if (name === "ifscCode") {
          errors = validateIFSCCode(value); // Custom validation for IFSC code
        } else if (name === "gstNumber") {
          errors = validateText(value); // Custom validation for GST number (optional)
        }else if (name === "aadharNumber") {
          errors = validateAadharNumber(formattedValue);
        }
      
        setValidationErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors, [name]: errors };
      
          // Check if all required fields are filled and there are no errors
          const requiredFields = [
            "accountNumber",
            "ifscCode",
            "accountHolderName",
            "aadharNumber",
            "panCardNumber",
          ];
      
          const allFieldsFilled = requiredFields.every(
            (field) => !!updatedInput[field]
          );
          const noErrors = Object.values(updatedErrors).every((error) => !error);
      
          // Enable the "Next" button if all fields are valid
          setIsSaveEnabled(allFieldsFilled && noErrors);
          return updatedErrors;
        });
      };
      const handleBankDetailsSubmit = async () => {
        try {
          const response = await api.put(`/vendor_register/update_bank_details`, {
            email: Input.email, 
            mobile_number: Input.mobileNumber, 
            account_number: Input.accountNumber,
            ifsc_code: Input.ifscCode,
            account_holder_name: Input.accountHolderName,
            aadhar_number: Input.aadharNumber,
            pan_card_number: Input.panCardNumber,
            gst_number: Input.gstNumber || "", // Optional field
          });
      
          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Bank Details Updated Successfully!",
              text: "Please proceed to the next step.",
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false,
            });
            setStep(3); // Move to the next step (Step 3)
          } else {
            Swal.fire({
              title: "Update Failed",
              text: response.data.msg || "Unable to update bank details. Please try again.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error during bank details update:", error);
          Swal.fire({
            title: "Error",
            text: "An unexpected error occurred. Might be a duplicate values.Please check.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      };    
      const handleEditModeToggle = () => {
        setIsEditMode(!isEditMode);
        if (!isEditMode) {
          handleBankDetailsSubmit();
        }
      };
      const handleBackToStep1 = () => {
        setStep(1);
        setIsEditingStep1(true); // Enable editing mode
      };
      const handleFileChange = (e, setFile) => {
        const file = e.target.files[0]; // Get the first selected file
        if (file) {
          setFile(file); // Update the corresponding state
        }
      };
      const handleBackToStep2 = () => {
        setStep(2);
        setIsEditingStep2(true); // Enable editing mode
      };
      const handleServiceBusinessInputChange = (e) => {
        const { name, value } = e.target;
        const updatedInput = { ...Inputservices, [name]: value };
      
        setInputservices(updatedInput);
      
        let errors = "";
      
        if (["businessName", "ownerName"].includes(name)) {
          errors = validateText(value);
        } else if (name === "mobileNumber") {
          errors = validateMobileNumber(value); // Example for mobile validation
        } else if (name === "email") {
          errors = validateEmail(value);
        } else if (name === "password") {
          errors = validatePassword(value);
        }
      
        setValidationErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors, [name]: errors };
      
          // Check if all fields are filled and there are no errors
          const requiredFields = [
            "businessName",          
           
            "mobileNumber",
            "email",
            "password",
          ];
      
          const allFieldsFilled = requiredFields.every(
            (field) => !!updatedInput[field]
          );
          const noErrors = Object.values(updatedErrors).every((error) => !error);
          setIsSaveservicesEnabled(allFieldsFilled && noErrors);
          return updatedErrors;
        });
      };
      const handleSubmit = async () => {
        // Prepare the form data for the backend
        const formData = new FormData();
        formData.append('vendor_photo', vendorPhoto);
        formData.append('shop_photo', shopPhoto);
        formData.append('gps_photo', gpsPhoto);
        formData.append("email", Input.email); // Add email from Input state
        formData.append("mobile_number", Input.mobileNumber); // Add mobile number from Input state
      
      
        try {
          // Call the API endpoint to submit the form data
          const response = await api.put(`/vendor_register/update_images`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
      
          if (response.data.success) {
            Swal.fire({
              icon: 'success',
              title: 'Photos Uploaded Successfully!',
              text: 'Your photos have been uploaded successfully.',
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false,
              didClose: () => {
                navigate("/login");
              },
            });
          
          } else {
            Swal.fire({
              title: 'Upload Failed',
              text: response.data.msg || 'Unable to upload photos. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        } catch (error) {
          console.error('Error during photo upload:', error);
          Swal.fire({
            title: 'Error',
            text: 'An unexpected error occurred. Please try again later.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      };
      const handleVideoUpload = (event) => {
        const fileArray = Array.from(event.target.files);
        const previewUrls = fileArray.map((file) => URL.createObjectURL(file));
        setPreviewVideos((prev) => [...prev, ...previewUrls]);
        setNewVideos((prev) => [...(prev || []), ...fileArray]); // Update parent state
      };
      const handleDayCheckboxChange = (e, day) => {
        const { checked } = e.target;
      
        // Update the state for the specific day
        setInput((prevInput) => ({
          ...prevInput,
          [`${day.toLowerCase()}Enabled`]: checked,
        }));
      
        // Update the array of selected days
        setSelectedDays((prevSelectedDays) => {
          if (checked) {
            // Add the day to the array
            return [...prevSelectedDays, day];
          } else {
            // Remove the day from the array
            return prevSelectedDays.filter((d) => d !== day);
          }
        });
      };
      
      const handleAvailabilityChange = (e) => {
        const { name, value } = e.target;
        const [day, timeType] = name.split(/(?=[A-Z])/); // Split name like 'mondayFromTime'
        setAvailability((prev) => ({
          ...prev,
          [day]: {
            ...prev[day],
            [timeType.toLowerCase()]: value,
          },
        }));
      };
      
      
    
    return (
        <>
        <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="dark">
        <Toolbar>
          {/* Icon Button for Mobile Menu */}
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: "block", sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Title / Logo */}
          <Typography
            variant="h6"
            component="div"
            color="inherit"
            sx={{ flexGrow: 1, fontWeight: "bold", textAlign: "left" }}
          >
            Servie App
          </Typography>

          {/* Navigation Buttons (visible on larger screens) */}
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            
            <Button color="inherit">User</Button>
            <Button color="inherit">Logout</Button>
          </Box>
        </Toolbar>
      </AppBar>
         </Box>
         {/* for bank details */}
         <Card
              className="customCard"
                sx={{
                    maxWidth: "1400px", // Full width
                    margin: "10px auto", // Center the content horizontally if needed
                    padding: "30px", // Add padding for spacing
                }}
                >
            <Grid container spacing={3}>
            <Grid item xs={12}>
                <MDBox mb={3}>
                <MDTypography variant="h4" align="center">
                    Basic Details
                </MDTypography>
                </MDBox>
            </Grid>
                      
                      
                     
                      <Grid item xs={12} sm={4}>          
                        <MDBox mb={3}>
                          <MDInput
                            type="text"
                            label="Name"
                            variant="standard"
                            name="businessName"
                           // value={Input.businessName || ""}
                            value={Inputservices.businessName || ""}
                            onChange={handleServiceBusinessInputChange}
                            helperText={validationErrors.businessName}
                            fullWidth
                            className={validationErrors.businessName ? "errorInput" : ""}
                            FormHelperTextProps={{
                              className: validationErrors.businessName ? "errorMessage" : "",
                            }}
                          />
                        </MDBox>
                      </Grid>
                    
                      
                      <Grid item xs={12} sm={4}>
                        <MDBox mb={3}>
                          <MDInput
                            type="tel"
                            label="Mobile Number"
                            variant="standard"
                            name="mobileNumber"
                            value={Inputservices.mobileNumber || ""}
                            onChange={handleServiceBusinessInputChange}
                            helperText={validationErrors.mobileNumber}
                            fullWidth
                            className={validationErrors.mobileNumber ? "errorInput" : ""}
                            FormHelperTextProps={{
                              className: validationErrors.mobileNumber ? "errorMessage" : "",
                            }}
                              />
                           
                        </MDBox>
                      </Grid>       
                      <Grid item xs={12} sm={4}>
                        <MDBox mb={3}>
                          <MDInput
                            type="email"
                            label="Email"
                            variant="standard"
                            name="email"
                            value={Inputservices.email || ""}
                            onChange={handleServiceBusinessInputChange}
                            helperText={validationErrors.email}
                            fullWidth
                            className={validationErrors.email ? "errorInput" : ""}
                            FormHelperTextProps={{
                              className: validationErrors.email ? "errorMessage" : "",
                            }}                           
                          />                          
                       
                        </MDBox>
                      </Grid>
                                 
             
        
            </Grid>
            </Card>
       
              {/* for bank details */}
              <Card
              className="customCard"
                sx={{
                     maxWidth: "1400px", // Full width
                    margin: "10px auto", // Center the content horizontally if needed
                    padding: "30px", // Add padding for spacing
                }}
                >
            <Grid container spacing={3}>
            <Grid item xs={12}>
                <MDBox mb={3}>
                <MDTypography variant="h4" align="center">
                    Bank Details
                </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} sm={4}>
                <MDBox mb={3}>
                <MDInput
                    type="text"
                    label="Account Number"
                    variant="standard"
                    name="accountNumber"
                    value={Input.accountNumber || ""}
                    onChange={handleBankDetailsChange}
                    fullWidth
                    helperText={validationErrors.accountNumber}
                    className={validationErrors.accountNumber ? "errorInput" : ""}
                    FormHelperTextProps={{
                    className: validationErrors.accountNumber ? "errorMessage" : "",
                    }}
                />
                </MDBox>
            </Grid>
            <Grid item xs={12} sm={4}>
                <MDBox mb={3}>
                <MDInput
                    type="text"
                    label="IFSC Code"
                    variant="standard"
                    name="ifscCode"
                    value={Input.ifscCode || ""}
                    onChange={handleBankDetailsChange}
                    fullWidth
                    helperText={validationErrors.ifscCode}
                    className={validationErrors.ifscCode ? "errorInput" : ""}
                    FormHelperTextProps={{
                    className: validationErrors.ifscCode ? "errorMessage" : "",
                    }}
                />
                </MDBox>
            </Grid>
            <Grid item xs={12} sm={4}>
                <MDBox mb={3}>
                <MDInput
                    type="text"
                    label="Account Holder Name"
                    variant="standard"
                    name="accountHolderName"
                    placeholder="Provide a name as per passbook"
                    value={Input.accountHolderName || ""}
                    onChange={handleBankDetailsChange}
                    fullWidth
                    helperText={validationErrors.accountHolderName}
                    className={validationErrors.accountHolderName ? "errorInput" : ""}
                    FormHelperTextProps={{
                    className: validationErrors.accountHolderName ? "errorMessage" : "",
                    }}
                
                />
                </MDBox>
            </Grid>
           
            </Grid>
            </Card>
            {/* Proof Details */}
            <Card
              className="customCard"
                sx={{
                    maxWidth: "1400px", // Full width
                    margin: "0 auto", // Center the content horizontally if needed
                    padding: "30px", // Add padding for spacing
                    marginTop: "20px"
                }}
                >
                <Grid item xs={12}>
                    <MDBox mb={3}>
                    <MDTypography variant="h4" align="center">
                        Proof Details
                    </MDTypography>
                    </MDBox>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <MDBox mb={3}>
                        <MDInput
                            type="text"
                            label="Gov. ID Proof"
                            variant="standard"
                            name="aadharNumber"
                            value={Input.aadharNumber || ""}
                            onChange={handleBankDetailsChange}
                            fullWidth
                            helperText={validationErrors.aadharNumber}
                            className={validationErrors.aadharNumber ? "errorInput" : ""}
                            FormHelperTextProps={{
                            className: validationErrors.aadharNumber ? "errorMessage" : "",
                            }}
                        />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MDBox mb={3}>
                        <MDInput
                            type="text"
                            label="PAN Card Number"
                            variant="standard"
                            name="panCardNumber"
                            value={Input.panCardNumber || ""}
                            onChange={handleBankDetailsChange}
                            helperText={validationErrors.panCardNumber}
                            className={validationErrors.panCardNumber ? "errorInput" : ""}
                            FormHelperTextProps={{
                            className: validationErrors.panCardNumber ? "errorMessage" : "",
                            }}
                            fullWidth
                        />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MDBox mb={3}>
                        <MDInput
                            type="text"
                            label="GST Number (Optional)"
                            variant="standard"
                            name="gstNumber"
                            value={Input.gstNumber || ""}
                            onChange={handleBankDetailsChange}
                            helperText={validationErrors.gstNumber}
                            className={validationErrors.gstNumber ? "errorInput" : ""}
                            FormHelperTextProps={{
                            className: validationErrors.gstNumber ? "errorMessage" : "",
                            }}
                            fullWidth
                        />
                        </MDBox>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <MDBox mb={3}>
                        <MDInput
                            type="text"
                            label="Driving License"
                            variant="standard"
                            name="aadharNumber"
                            value={Input.aadharNumber || ""}
                            onChange={handleBankDetailsChange}
                            fullWidth
                            helperText={validationErrors.aadharNumber}
                            className={validationErrors.aadharNumber ? "errorInput" : ""}
                            FormHelperTextProps={{
                            className: validationErrors.aadharNumber ? "errorMessage" : "",
                            }}
                        />
                        </MDBox>
                    </Grid>
              
                </Grid>
                
            </Card>
          
               {/* for service details */}
            <Card
              className="customCard"
                sx={{
                    maxWidth: "1400px", // Full width
                    margin: "0 auto", // Center the content horizontally if needed
                    padding: "30px", // Add padding for spacing
                    marginTop: "20px"
                }}
                >
            <Grid container spacing={3}>
            <Grid item xs={12}>
                <MDBox mb={3}>
                    <MDTypography variant="h4" align="center">
                        Services Details
                    </MDTypography>
                </MDBox>
            </Grid>
          
                <Grid item xs={12} sm={4} mt={1}>
                    <MDBox mb={3}>
                        <FormControl variant="standard" fullWidth>
                        <InputLabel id="business-type-label">Services Type</InputLabel>
                        <Select
                            label="business-type-label"
                            name="businessType"
                            value={servicetype || ""}
                            onChange={handleServiceBusinessInputChange}
                        >
                            <MenuItem value="Finance">Finance</MenuItem>
                            <MenuItem value="Trading">Trading</MenuItem>
                            <MenuItem value="Fitness">Fitness</MenuItem>
                            <MenuItem value="Consulting">Consulting</MenuItem>
                            <MenuItem value="Construction">Construction</MenuItem>
                        
                        </Select>
                        </FormControl>
                    </MDBox>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MDBox mb={3}>
                    <MDInput
                        type="text"
                        label="Sub Service Category"
                        variant="standard"
                        name="gstNumber"
                        value={Input.gstNumber || ""}
                        onChange={handleBankDetailsChange}
                        helperText={validationErrors.gstNumber}
                        className={validationErrors.gstNumber ? "errorInput" : ""}
                        FormHelperTextProps={{
                        className: validationErrors.gstNumber ? "errorMessage" : "",
                        }}
                        fullWidth
                    />
                    </MDBox>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MDBox mb={3}>
                    <MDInput
                        type="text"
                        label="Experiance"
                        variant="standard"
                        name="gstNumber"
                        value={Input.gstNumber || ""}
                        onChange={handleBankDetailsChange}
                        helperText={validationErrors.gstNumber}
                        className={validationErrors.gstNumber ? "errorInput" : ""}
                        FormHelperTextProps={{
                        className: validationErrors.gstNumber ? "errorMessage" : "",
                        }}
                        fullWidth
                    />
                    </MDBox>
                </Grid>
                <Grid item xs={12} sm={4}>
                
                    <MDBox mb={3}>
                        <MDInput
                        type="text"
                        label="Details"
                        variant="standard"
                        name="details"
                        value={Input.details || ""}
                        onChange={handleBankDetailsChange}
                        fullWidth
                        helperText={validationErrors.details}
                        className={validationErrors.details ? "errorInput" : ""}
                        FormHelperTextProps={{
                            className: validationErrors.details ? "errorMessage" : "",
                        }}
                        multiline
                        rows={4} // Adjust the number of rows as per your requirement
                        placeholder="Enter details including Description and about services"
                        />
                    </MDBox>
                
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MDBox mb={3}>
                    <MDBox mb={3}>
                        <MDInput
                        type="text"
                        label="Operating location"
                        variant="standard"
                        name="details"
                        value={Input.details || ""}
                        onChange={handleBankDetailsChange}
                        fullWidth
                        helperText={validationErrors.details}
                        className={validationErrors.details ? "errorInput" : ""}
                        FormHelperTextProps={{
                            className: validationErrors.details ? "errorMessage" : "",
                        }}
                        multiline
                        rows={4} // Adjust the number of rows as per your requirement
                        placeholder="Enter Operating Location with Pincode"
                        />
                    </MDBox>
                    </MDBox>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MDBox mb={3}>
                    <MDBox mb={3}>
                        <MDInput
                        type="text"
                        label="Home Address"
                        variant="standard"
                        name="details"
                        value={Input.details || ""}
                        onChange={handleBankDetailsChange}
                        fullWidth
                        helperText={validationErrors.details}
                        className={validationErrors.details ? "errorInput" : ""}
                        FormHelperTextProps={{
                            className: validationErrors.details ? "errorMessage" : "",
                        }}
                        multiline
                        rows={4} // Adjust the number of rows as per your requirement
                        placeholder="Enter Home Location with Pincode."
                        />
                    </MDBox>
                    </MDBox>
                </Grid>
            </Grid>
            </Card>
                 {/* Availability Details */}
            <Card
                className="customCard"
                sx={{
                    maxWidth: "1400px", // Full width
                    margin: "0 auto", // Center the content horizontally
                    padding: "30px", // Add padding for spacing
                    marginTop: "20px"
                }}
                >
            <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={12}>
                <MDBox mb={3}>
                <MDTypography variant="h4" align="center">
                    Availability Details
                </MDTypography>
                </MDBox>
            </Grid>

            <Grid container justifyContent="center" alignItems="center">
            <Grid container justifyContent="center" alignItems="center">
                <Grid container spacing={3}>
                    {/* First row with 4 elements */}
                    {["Monday", "Tuesday", "Wednesday", "Thursday"].map((day) => (
                    <Grid item xs={12} sm={3} key={day}>
                        <MDBox display="flex" alignItems="center" justifyContent="flex-start" mb={2}>
                        <Checkbox
                            name={`${day.toLowerCase()}Enabled`}
                            checked={Input[`${day.toLowerCase()}Enabled`] || false}
                            onChange={(e) => handleDayCheckboxChange(e, day)}
                        />
                        <MDTypography variant="body1" ml={1}>
                            {day}
                        </MDTypography>
                        </MDBox>
                    </Grid>
                    ))}

                    {/* Second row with 3 elements */}
                    {["Friday", "Saturday", "Sunday", ""].map((day, index) => (
                    <Grid item xs={12} sm={3} key={index}>
                        {day && (
                        <MDBox display="flex" alignItems="center" justifyContent="flex-start" mb={2}>
                            <Checkbox
                            name={`${day.toLowerCase()}Enabled`}
                            checked={Input[`${day.toLowerCase()}Enabled`] || false}
                            onChange={(e) => handleDayCheckboxChange(e, day)}
                            />
                            <MDTypography variant="body1" ml={1}>
                            {day}
                            </MDTypography>
                        </MDBox>
                        )}
                    </Grid>
                    ))}
                </Grid>
            </Grid>

            </Grid>
            </Grid>

            </Card>


              {/* for photos */}
            <Card
                className="customCard"
                sx={{
                    maxWidth: "1400px", // Increased the card width
                    margin: "auto",
                    padding: "30px", // Added padding for spacing
                    marginTop: "20px",
                }}
                >
                <Grid container spacing={3}>
                    {/* Title */}
                    <Grid item xs={12}>
                    <MDBox mb={3}>
                        <MDTypography variant="h4" align="center">
                        Photos and Video Upload
                        </MDTypography>
                    </MDBox>
                    </Grid>

                    {/* Inputs in a Single Row */}
                    <Grid item xs={3} textAlign="center">
                    <MDBox mb={2}>
                        <MDButton variant="gradient" color="info" component="label">
                        Profile PhotoCopy
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) => handleFileChange(e, setVendorPhoto)}
                        />
                        </MDButton>
                    </MDBox>
                    {vendorPhoto && (
                        <MDTypography mt={1} variant="caption">
                        {vendorPhoto.name}
                        </MDTypography>
                    )}
                    </Grid>

                    <Grid item xs={3} textAlign="center">
                    <MDBox mb={2}>
                        <MDButton variant="gradient" color="info" component="label">
                        Work Image
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) => handleFileChange(e, setShopPhoto)}
                        />
                        </MDButton>
                    </MDBox>
                    {shopPhoto && (
                        <MDTypography mt={1} variant="caption">
                        {shopPhoto.name}
                        </MDTypography>
                    )}
                    </Grid>

                    <Grid item xs={3} textAlign="center">
                    <MDBox mb={2}>
                        <MDButton variant="gradient" color="info" component="label">
                        Shop's GPS Photocopy
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) => handleFileChange(e, setGpsPhoto)}
                        />
                        </MDButton>
                    </MDBox>
                    {gpsPhoto && (
                        <MDTypography mt={1} variant="caption">
                        {gpsPhoto.name}
                        </MDTypography>
                    )}
                    </Grid>

                    <Grid item xs={3} textAlign="center">
                    <MDBox mb={2}>
                        <MDButton variant="gradient" color="info" component="label">
                        Upload Video
                        <input
                            type="file"
                            accept="video/*"
                            hidden
                            onChange={handleVideoUpload}
                        />
                        </MDButton>
                    </MDBox>
                    {newVideos.length > 0 && (
                        <MDTypography mt={1} variant="caption">
                        {newVideos.length} video(s) selected
                        </MDTypography>
                    )}
                    </Grid>

                    {/* Display Uploaded Videos */}
                    {newVideos.length > 0 && (
                    <Grid container spacing={2} mt={3}>
                        {newVideos.map((url, index) => (
                        <Grid item xs={4} key={`new-vid-${index}`}>
                            <video
                            width="100%"
                            controls
                            style={{
                                borderRadius: "8px",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            }}
                            >
                            <source src={url} type="video/mp4" />
                            Your browser does not support the video tag.
                            </video>
                        </Grid>
                        ))}
                    </Grid>
                    )}

                   
                </Grid>
            </Card>
            {/* submit */}
            <Card
                className="customCard"
                sx={{
                    maxWidth: "1400px", // Increased the card width
                    margin: "auto",
                    padding: "30px", // Added padding for spacing
                    marginTop: "20px",
                }}
                >
                 {/* Navigation Buttons */}
                 <Grid item xs={10}>
                    <MDBox display="flex" justifyContent="center" mb={3}>                     

                        {/* Submit Button */}
                        <MDButton
                        type="button"
                        onClick={handleSubmit}
                        variant="gradient"
                        color="info"
                        disabled={!vendorPhoto || !shopPhoto || !gpsPhoto}
                        >
                        Sign Up
                        </MDButton>
                    </MDBox>
                    </Grid>
            </Card>
       
        </>
      );
}
export default Nonregistered;